import { Injectable } from '@angular/core';
import { LibraryV2DataService } from '../../../../core/services/library-v2/library-v2-data.service';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { HttpMethodsService } from '../../../../common/utility/http-methods.service'
import { environment } from 'src/environments/environment';
import { takeUntil, tap, catchError } from 'rxjs/operators';
import { Subject, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UlthreedmarkService {
  private ngUnsubscribe = new Subject<boolean>();
  fpsData: any[] = [];
  ulThreeDMarkData: any;
  ul3ddata: any;
  constructor(private libraryService: LibraryV2DataService,
    private qrCodeService: QrCodeService,    
    private httpService: HttpMethodsService,
  ) { }

  getULThreeDMarkData() {
    const cpufam = GlobalConstants.PANTHER_LAKE_BADGES_FAMILY_MAPPING[this.qrCodeService.qrInput.ProcessorBadge];
    if (this.qrCodeService.isPantherLakeGaming) {
      this.ulThreeDMarkData = this.libraryService.getFactTagsDetails(GlobalConstants.PANTHER_LAKE, GlobalConstants.FPS, GlobalConstants.GAMING, GlobalConstants.DEFAULT_TITLE);
      this.ulThreeDMarkData.badgeUrl = this.ulThreeDMarkData.badgeUrl.replace(GlobalConstants.XX, cpufam);
      this.ulThreeDMarkData.tr_subtitle = this.ulThreeDMarkData.tr_subtitle.replace(GlobalConstants.XX, cpufam);
      this.ulThreeDMarkData.tr_title = this.ulThreeDMarkData.tr_title.replace(GlobalConstants.XX, cpufam);

    } else if (this.qrCodeService?.isPantherLake12Xe) {
      this.ulThreeDMarkData = this.libraryService.getFactTagsDetails(GlobalConstants.PANTHER_LAKE, GlobalConstants.FPS, GlobalConstants.PTLXE, GlobalConstants.DEFAULT_TITLE);
      this.ulThreeDMarkData.badgeUrl = this.ulThreeDMarkData.badgeUrl.replace(GlobalConstants.XX, GlobalConstants.PANTHER_LAKE_BADGES_FAMILY_MAPPING[this.qrCodeService?.qrInput?.ProcessorBadge]);
      this.ulThreeDMarkData.tr_subtitle = this.ulThreeDMarkData.tr_subtitle.replace(GlobalConstants.XX, GlobalConstants.PANTHER_LAKE_BADGES_FAMILY_MAPPING[this.qrCodeService?.qrInput?.ProcessorBadge]);
      this.ulThreeDMarkData.tr_title = this.ulThreeDMarkData.tr_title.replace(GlobalConstants.XX, GlobalConstants.PANTHER_LAKE_BADGES_FAMILY_MAPPING[this.qrCodeService?.qrInput?.ProcessorBadge]);

    } else if (this.qrCodeService?.isPantherLakeStd) {
      this.ulThreeDMarkData = this.libraryService.getFactTagsDetails(GlobalConstants.PANTHER_LAKE, GlobalConstants.FPS, GlobalConstants.STANDARD, GlobalConstants.DEFAULT_TITLE);
      this.ulThreeDMarkData.badgeUrl = this.ulThreeDMarkData.badgeUrl.replace(GlobalConstants.XX, cpufam);
      this.ulThreeDMarkData.tr_subtitle = this.ulThreeDMarkData.tr_subtitle.replace(GlobalConstants.XX, cpufam);
      this.ulThreeDMarkData.tr_title = this.ulThreeDMarkData.tr_title.replace(GlobalConstants.XX, cpufam);
    }
    return this.ulThreeDMarkData;
  }

  fetchULThreeDMarkFPSData(): void {
    const deviceId = this.qrCodeService?.qrInput?.DeviceId;
    const fpsurl = environment.deviceDetailsUrl + deviceId;
    
    this.ul3ddata = this.httpService?.get(fpsurl)?.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {        
        if (!data) {
          this.fpsData = [];
          return;
        }
        let fps = JSON.parse(data?.device?.deviceConfigurations);
        if (!fps?.system?.fps_scores) {
          this.fpsData = [];
          return;
        }
        this.fpsData = fps.system.fps_scores;         
      },
      (error) => {
          console.log("Error fetching the fpsdata")
        }
    );    
  }

  getFpsData(): any[] {    
    return this.fpsData;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
